<ng-container *ngIf="flavor === 'bootstrap'; else matFlavor">
    <span [title]="tooltipText"
          class="detail-action-button-wrap">
        <button type="button"
                [class]="btnClass(action.tone)"
                [disabled]="isDisabled"
                [attr.data-testid]="action.testId || null"
                (click)="onClick()">
            <span *ngIf="action.loading" class="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>
            <i *ngIf="!action.loading && action.icon" [class]="'fa ' + action.icon"></i>
            {{ action.label }}
        </button>
    </span>
</ng-container>

<ng-template #matFlavor>
    <span [matTooltip]="tooltipText"
          matTooltipPosition="above"
          class="detail-action-button-wrap">
        <button *ngIf="isMatRaised; else flatBtn"
                mat-raised-button
                [color]="matColor(action.tone) || null"
                [class]="matExtraClass"
                [disabled]="isDisabled"
                [attr.data-testid]="action.testId || null"
                (click)="onClick()">
            <mat-spinner *ngIf="action.loading" diameter="18" class="me-2"></mat-spinner>
            <mat-icon *ngIf="!action.loading && materialIconName as mi">{{ mi }}</mat-icon>
            {{ action.label }}
        </button>
        <ng-template #flatBtn>
            <button mat-button
                    [color]="matColor(action.tone) || null"
                    [disabled]="isDisabled"
                    [attr.data-testid]="action.testId || null"
                    (click)="onClick()">
                <mat-spinner *ngIf="action.loading" diameter="18" class="me-2"></mat-spinner>
                <mat-icon *ngIf="!action.loading && materialIconName as mi">{{ mi }}</mat-icon>
                {{ action.label }}
            </button>
        </ng-template>
    </span>
</ng-template>
